<section class="py-6 border-b border-b-shs-gray-4" [formGroup]="regionForm!">
    <h2 class="text-base font-bold text-font-primary">Customer Information</h2>
    <div class="max-w-input mt-4 flex flex-col gap-2">
        <sag-ui-select
            [required]="true"
            label="Select Region"
            formControlName="region"
            placeholder="Choose your region"
        >
            @for (region of regions | keyvalue; track $index) {
            <sag-ui-option [value]="region.value">{{ region.value }}</sag-ui-option>
            }
        </sag-ui-select>
        <br />
        <app-region-select [region]="regionForm?.controls?.region?.value ?? null"></app-region-select>
    </div>
</section>
